import { Dialog } from "@mui/material";
import styles from "./idmodal.module.css";
import { X } from "react-feather";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import dayjs from "dayjs";

const IDModal = ({ selectecId, docModalOpen, setDocModalOpen, setLoading }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [fileURL, setFileURL] = useState("");
    const [verifiedAt, setVerifiedAt] = useState(null);

    useEffect(() => {
        const getFileUrl = async () => {
            setLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/id-file/" + selectecId, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setFileURL(response.data.data?.file_url);
                setVerifiedAt(response.data.data?.verified_at);
            }).catch(() => { }).finally(() => {
                setLoading(false);
            });
        }
        if (selectecId) {
            getFileUrl();
        }
    }, [selectecId]);

    return (<Dialog
        open={docModalOpen}
        onClose={() => setDocModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
            style: { borderRadius: 16, padding: '8px 0' }
        }}
    >
        <div className={`${styles.docModalContainer}`}>
            <div className={`${styles.docModalHeader}`}>
                <div>
                    <div className={`${styles.docModalTitle}`}>ID Document</div>
                    <div className={`${styles.docModalSub}`}>Verified via Stripe Identity on {verifiedAt && dayjs(verifiedAt).format('MMM D, YYYY')}</div>
                </div>
                <button className={`${styles.closeBtn}`} onClick={() => setDocModalOpen(false)} aria-label="Close">
                    <X size={20} />
                </button>
            </div>

            <div className={`${styles.docModalBody}`}>
                {fileURL !== "" && <img src={fileURL} alt="" style={{ verticalAlign: 'middle', maxWidth: '100%' }} />}
            </div>

            <div className={`${styles.docModalFooter}`}>
                <button className={`${styles.cancelBtn}`} onClick={() => setDocModalOpen(false)}>Close</button>
            </div>
        </div>
    </Dialog>);
}

export default IDModal;